import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import VerbaExtra2 from '../models/verba-extra-2.model';

@Injectable({
  providedIn: 'root'
})
export class AnexoService {

  constructor(
    private http: HttpClient
  ) { }

  downloadAnexoVerbaExtra(item: VerbaExtra2): Observable<HttpResponse<Blob>> {
    const url = `${environment.apiAddress}/arquivos-externo/verba-extra/${item.id}`;
    return this.http.get(url, {
      headers: new HttpHeaders({ Accept: 'application/octet-stream' }),
      observe: 'response',
      responseType: 'blob',
    });
  }

  public exportArquivo(response: any, fileName: string) {
    const memoryLink = document.createElement('a');
    const blob: any = response.body;
    const urlFile = window.URL.createObjectURL(blob);
    memoryLink.setAttribute('href', urlFile);
    memoryLink.setAttribute('download', `anexos-${fileName}.zip`);
    memoryLink.style.display = 'none';
    memoryLink.click();
  }

}
